import React, { useState } from "react";
import { Box, Drawer as MuiDrawer, AppBar as MuiAppBar, Toolbar, List, CssBaseline, IconButton, ListItemButton, ListItemIcon, ListItemText, Menu, MenuItem, Typography, useMediaQuery } from '@mui/material';
import { styled, useTheme } from '@mui/material/styles';
import MenuOpenIcon from '@mui/icons-material/MenuOpen';
import { NavLink } from "react-router-dom";
import DashboardIcon from '@mui/icons-material/Dashboard';
// import logo from "../../img/groovenexus.png";
import logo from "../../img/general/logo4 (1).svg";
import User from '../user';
// import DynamicToggleTabs from '../../components/reusableComponents/DynamicToggleTabs';
// import { setSelectedValue } from '../../redux/loader/loaderActions';
import { useDispatch ,useSelector} from 'react-redux';
import LogoutIcon from '@mui/icons-material/Logout';
import GraphicEqIcon from '@mui/icons-material/GraphicEq';
import LibraryMusicIcon from '@mui/icons-material/LibraryMusic';
import PlayCircleFilledIcon from '@mui/icons-material/PlayCircleFilled';
import PlaylistPlayIcon from '@mui/icons-material/PlaylistPlay';
import Collapse from '@mui/material/Collapse';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import { setRevnueValue, setTabValue } from '../../redux/royalty/royaltyDataActions';
import SquareIcon from '@mui/icons-material/Square';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import SupervisedUserCircleIcon from '@mui/icons-material/SupervisedUserCircle';
const drawerWidth = 300;

const AppBar = styled(MuiAppBar)(({ theme }) => ({
  zIndex: theme.zIndex.drawer + 1,
  backgroundColor: "white",
  boxShadow: "none",
  borderBottom: "1px solid #ddd",
}));

// const openedMixin = (theme) => ({
//   width: drawerWidth,
//   transition: theme.transitions.create('width', {
//     easing: theme.transitions.easing.sharp,
//     duration: theme.transitions.duration.enteringScreen,
//   }),
//   overflowX: 'hidden',
// });

// const closedMixin = (theme) => ({
//   transition: theme.transitions.create('width', {
//     easing: theme.transitions.easing.sharp,
//     duration: theme.transitions.duration.leavingScreen,
//   }),
//   overflowX: 'hidden',
//   width: '95px !important',
//   height: '90% !important',
//   // width: `calc(${theme.spacing(7)} + 1px)`,
//   [theme.breakpoints.up('sm')]: {
//     width: `calc(${theme.spacing(8)} + 1px)`,
//   },
// });

// const AppBar = styled(MuiAppBar, {
//   shouldForwardProp: (prop) => prop !== 'open',
// })(({ theme, open }) => ({
//   zIndex: theme.zIndex.drawer + 1,
//   transition: theme.transitions.create(['width', 'margin'], {
//     easing: theme.transitions.easing.sharp,
//     duration: theme.transitions.duration.leavingScreen,
//   }),
//   ...(open && {
//     transition: theme.transitions.create(['width', 'margin'], {
//       easing: theme.transitions.easing.sharp,
//       duration: theme.transitions.duration.enteringScreen,
//     }),
//   }),
// }));

// const Drawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(
//   ({ theme, open }) => ({
//     width: drawerWidth,
//     flexShrink: 0,
//     whiteSpace: 'nowrap',
//     boxSizing: 'border-box',
//     ...(open && {
//       ...openedMixin(theme),
//       '& .MuiDrawer-paper': openedMixin(theme),
//     }),
//     ...(!open && {
//       ...closedMixin(theme),
//       '& .MuiDrawer-paper': closedMixin(theme),
//     }),
//   }),
// );

const StyledList = styled(List)({
  // selected and (selected + hover) states
  '&& .Mui-selected, && .Mui-selected:hover': {
    backgroundColor: 'red',
    '&, & .MuiListItemIcon-root': {
      color: 'pink',
    },
  },
  // hover states
  '& .MuiSvgIcon-root': { color: '#FFFFFF' },
  '& .active .MuiListItemButton-root': {
    backgroundColor: '#fff',
    '& .MuiSvgIcon-root, &, & .MuiListItemIcon-root': { color: 'red' },
  },
  '& .MuiListItemButton-root': { color: '#fff' },
  '& .MuiListItemButton-root:hover': {
    backgroundColor: '#FFF',
    '&, & .MuiListItemIcon-root': {
      color: 'red',
    },
    '& .MuiSvgIcon-root': { color: 'red' },
  },
});
const hwset = { height: '18px', width: '18px' }

const navItems = [
  { id: 1, to: "/dashboard", text: "Dashboard", icon: <DashboardIcon sx={hwset} />, },
  { id: 2, to: "/artistlist", text: "Artist List", icon: <LibraryMusicIcon sx={hwset} />, },
  {
    id: 3, to: "/importrevenue", text: "Royalty Calculation", icon: <MonetizationOnIcon sx={hwset} className="faIcons" />, hasCollapse: true,
    collapseItems: [{ id: 4, to: "/importrevenue", text: "Import Royalty", icon: <SquareIcon sx={hwset} style={{ transform: 'rotate(45deg)', height: '10px', width: '10px' }} />, },
      { id: 5, to: "/payout", text: "Royalty Payout", icon: <SquareIcon sx={hwset} style={{ transform: 'rotate(45deg)', height: '10px', width: '10px' }} />, }
    ]
  },
  {
    id: 5, to: "/discover", text: "Discover", icon: <GraphicEqIcon sx={hwset} />, hasCollapse: true,
    collapseItems: [
      { id: 4, to: "/discover-playlist", text: "Playlist", icon: <SquareIcon sx={hwset} style={{ transform: 'rotate(45deg)', height: '10px', width: '10px' }} /> },
      { id: 4, to: "/discover-music", text: "Music", icon: <SquareIcon sx={hwset} style={{ transform: 'rotate(45deg)', height: '10px', width: '10px' }} />, }
    ]
  },
  { id: 6, to: "/studiolist", text: "Studio List", icon: <GraphicEqIcon sx={hwset} />, onlyForAccountant: true}, { id: 7, to: "/albumlist", text: "Release List", icon: <PlaylistPlayIcon sx={hwset} />, },
  { id: 11, to: "/status-requests", text: "Status Requests", icon: <PlaylistPlayIcon sx={hwset} />, wrapText: true },
  { id: 8, to: "/songpitch", text: "Pitching", icon: <SupervisedUserCircleIcon sx={hwset} /> },
  { 
    // id: 9, to: "/submitdemo", text: "Song Demo", icon: <PlayCircleFilledIcon sx={hwset} />, }, {
    id: 10, to: "/logout", text: "Logout", icon: <LogoutIcon sx={hwset} style={{ transform: 'rotate(180deg)' }} />,
  }
];

export default function MiniDrawer() {
  const dispatch = useDispatch()
  const [open, setOpen] = React.useState(false);
  const [openRoyalty, setOpenRoyalty] = useState(false);
  const [menuRowId, setMenuRowId] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
   const userData = useSelector((state) => state.userData.userData);

  const handleDrawerOpen = () => {
    setOpen((prev) => !prev);
    handleClose()
  };


  // const handleTabSelect = (newValue) => {
  //   dispatch(setSelectedValue(newValue))
  // };
  const handleClickMenu = (e, item) => {
    setAnchorEl(e.currentTarget);
    setMenuRowId(item.id);

    if (item.text === "Royalty Calculation") {
      handleClick();
    } else {
      dispatch(setTabValue(""));
      dispatch(setRevnueValue(2));
    }
  };

  function handleRoyaltyClick() {
    dispatch(setTabValue(''))
    dispatch(setRevnueValue(2))
  }

  const handleClick = () => {
    dispatch(setTabValue(''))
    setOpenRoyalty(!openRoyalty);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setMenuRowId(null);
  };

  const handleNavLinkClick = () => {
    if (isMobile) {
      setOpen(false);
    }
  };

   const filteredNavItems = userData?.is_accountant
    ? navItems.filter(item => item.onlyForAccountant)
    : navItems;


  const listRender = (item) => {
    return (
      <ListItemButton className={`${open ? '' : 'pb-0'} rounded-3 `} onClick={(e) => handleClickMenu(e, item)} sx={{
        minHeight: 48,
        marginTop: '14px !important',
        justifyContent: open ? 'initial' : 'center',
        flexDirection: open ? '' : 'column',
        alignItems: open ? '' : 'center',
        px: 2.5,
      }}>
        <ListItemIcon sx={{
          minWidth: 0,
          mr: open ? 3 : '0px',
          justifyContent: 'center',
        }}>
          {item.icon}
          {(item.hasCollapse && !open) ? <ChevronRightIcon sx={{
            position: 'absolute',
            right: '3px',
            top: '7px',
            width: '18px',
            height: '18px'
          }} /> : null}
        </ListItemIcon>
        <ListItemText primary={<Typography variant="span" sx={!open && {
          fontSize: '11px', display: (item.hasCollapse || item.wrapText) ? 'block' : 'inline-block',
          whiteSpace: (item.hasCollapse || item.wrapText) ? 'break-spaces' : 'nowrap',
          textAlign: 'center',
        }}>{item.text}</Typography>} />
        {(item.hasCollapse && open) ? (openRoyalty ? <ExpandLess /> : <ExpandMore />) : null}
      </ListItemButton >
    )
  }

  return (
    <Box sx={{ display: 'flex' }}>
      <CssBaseline />
      <AppBar className='bg-white shadow-none border' position="fixed" open={open}>
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={handleDrawerOpen}
            className="text-black ms-1"
            edge="start"

          >
            <MenuOpenIcon />
          </IconButton>
          <Box sx={{
            marginLeft: 4,
          }}>
            <img src={logo} className="w-100" />
          </Box>
          <Box className='d-flex align-items-center gap-5 w-100 justify-content-end' >
            {/* <DynamicToggleTabs value1="STUDIO" value2="CREATOR" onSelectTab={handleTabSelect} /> */}
            <User />
          </Box>
        </Toolbar>
      </AppBar>
      <MuiDrawer
        variant={isMobile ? "temporary" : "permanent"}
        open={open}
        onClose={() => setOpen(false)}
        sx={{
          flexShrink: 0,
          width: open ? drawerWidth : 95,
          "& .MuiDrawer-paper": {
            width: open ? drawerWidth : 95,
            marginTop: isMobile ? '0' : '4rem',
            padding: "10px",
            boxSizing: "border-box",
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
            background: 'linear-gradient(180deg, #ED1C24 0%, #AA0066 100%)',
            boxShadow: '0px 4px 15px rgba(0, 0, 0, 0.55)',
          },
        }}
      >
        <StyledList sx={{ padding: '0px' }}>
          <List sx={{ width: "100%", maxWidth: 360 }} className="p-0" component="nav" aria-labelledby="nested-list-subheader">
            {filteredNavItems.map((item, index) => (
              <React.Fragment key={index}>
                {item.hasCollapse ? (
                  <div>
                    {listRender(item)}
                    <Menu
                      id={`basic-menu-${item.id}`}
                      anchorEl={anchorEl}
                      open={!open && menuRowId === item.id}
                      onClose={handleClose}
                      anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                      }}
                      MenuListProps={{
                        'aria-labelledby': `basic-button-${item.id}`,
                      }}
                    >
                      {item.collapseItems.map((option, i) => (
                        <MenuItem
                          key={i}
                          to={option.to}
                          className="p-0"
                          onClick={handleClose}
                        >
                          <NavLink to={option.to} className="nav-list-items py-1 " onClick={handleNavLinkClick}>
                            {/* <ListItemText primary={option.text} /> */}
                            <ListItemButton className="tab-items rounded-3 ps-0" >
                              <ListItemIcon className="justify-content-center align-items-center" >
                                {option.icon}
                              </ListItemIcon>
                              <ListItemText primary={<Typography variant="span">{option.text}</Typography>} />
                            </ListItemButton>
                          </NavLink>
                        </MenuItem>
                      ))}
                    </Menu>
                  </div>)
                  :
                  (<NavLink to={item.to} className='nav-list-items ' onClick={handleNavLinkClick}>
                    {listRender(item)}
                  </NavLink>)
                }
                {(item.hasCollapse && open) && (
                  <Collapse in={openRoyalty} timeout={300} unmountOnExit>
                    {item.collapseItems.map((collapseItem, collapseIndex) => (
                      <NavLink key={collapseIndex} to={collapseItem.to} className="nav-list-items" onClick={handleNavLinkClick}>
                        <ListItemButton onClick={collapseItem.handleClick} className="tab-items my-2 rounded-3" >
                          <ListItemIcon className="p-2 justify-content-center align-items-center" >
                            {collapseItem.icon}
                          </ListItemIcon>
                          <ListItemText primary={collapseItem.text} />
                        </ListItemButton>
                      </NavLink>
                    ))}
                  </Collapse>
                )}
                {/* {(!open && item.hasCollapse) && (<Menu
                  id={`basic-menu-${item.id}`}
                  anchorEl={anchorEl}
                  open={menuRowId === item.id}
                  onClose={handleClose}
                  anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                  }}
                  MenuListProps={{
                    'aria-labelledby': `basic-button-${item.id}`,
                  }}
                >
                  {item.collapseItems.map((option, i) => (
                    <MenuItem
                      key={i}
                      to={option.to}
                    >
                      <NavLink onClick={handleClose} to={option.to} sx={{color:'#000'}} className="nav-list-items py-1">
                        <ListItemText primary={option.text} />
                      </NavLink>
                    </MenuItem>
                  ))}
                </Menu>)} */}
              </React.Fragment>
            ))}
          </List>
        </StyledList>
      </MuiDrawer>
    </Box>
  );
}
